import { storage } from '@/lib/storage';
import { EikoLogo } from '@/components/EikoLogo';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { motion } from 'framer-motion';
import { FileQuestion } from 'lucide-react';
import { Link } from 'react-router-dom';

const cardVariants = {
  hidden: { opacity: 0, scale: 0.95, filter: 'blur(8px)' },
  visible: {
    opacity: 1,
    scale: 1,
    filter: 'blur(0px)',
    transition: {
      duration: 0.6,
      ease: [0.25, 0.46, 0.45, 0.94] as const,
    },
  },
};

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.08,
      delayChildren: 0.1,
    },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 20, filter: 'blur(4px)' },
  visible: {
    opacity: 1,
    y: 0,
    filter: 'blur(0px)',
    transition: {
      duration: 0.5,
      ease: [0.25, 0.46, 0.45, 0.94] as const,
    },
  },
};

export function NotFoundView() {
  storage.clear();

  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-stone-50">
      <motion.div
        variants={cardVariants}
        initial="hidden"
        animate="visible"
        className="relative z-10 w-full max-w-[420px] mx-4"
      >
        <div
          className={cn(
            'rounded-2xl border border-stone-200 p-8 sm:p-10',
            'bg-white',
            'shadow-sm',
          )}
        >
          <motion.div
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            className="flex flex-col"
          >
            {/* Brand */}
            <motion.div variants={itemVariants} className="mb-8 flex justify-center">
              <EikoLogo className="h-14 text-emerald-600" />
            </motion.div>

            {/* Icon */}
            <motion.div variants={itemVariants} className="mb-6 flex justify-center">
              <div className="flex h-16 w-16 items-center justify-center rounded-full bg-emerald-50">
                <FileQuestion className="h-8 w-8 text-emerald-600" />
              </div>
            </motion.div>

            {/* Title */}
            <motion.div variants={itemVariants} className="mb-6 text-center">
              <h2 className="text-lg font-medium text-stone-800">
                Page non trouvée
              </h2>
              <p className="mt-1.5 text-sm text-stone-500">
                Cette page n'existe pas ou vous n'avez pas accès à cette
                ressource.
              </p>
            </motion.div>

            {/* CTA */}
            <motion.div variants={itemVariants}>
              <Button
                asChild
                className={cn(
                  'w-full h-11 rounded-lg text-sm font-semibold',
                  'bg-emerald-600 text-white',
                  'hover:bg-emerald-700',
                  'transition-all duration-300',
                )}
              >
                <Link to="/login">Retour à la connexion</Link>
              </Button>
            </motion.div>
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
}
